import { Pipe, PipeTransform } from '@angular/core';

import { isNil } from 'src/utils/utils';

@Pipe({ name: 'isNotEmptyObject' })
export class IsNotEmptyObjectPipe implements PipeTransform {
  transform(obj: any): boolean {
    return !isNil(obj) && Object.keys(obj).length > 0;
  }
}
